var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-home-page"},[_c('div',{staticClass:"top-zk-div"}),_c('userinfleftmen',{staticClass:"left-menu",attrs:{"activeIndex":'/companyinteraction'}}),_c('companyinteraction',{staticClass:"userinf-index"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }